"use client";

import { useState } from "react";
import { ArrowRight, BadgeCheck, Briefcase, ChevronRight, ShieldCheck, Wrench, X } from "lucide-react";
import EnTete from "@/reusable_sections/Header";
import PiedDePage from "@/reusable_sections/Footer";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
const reperes = ["Rénovation, équipement, dépannage et amélioration énergétique", "Des métiers structurés par besoin pour trouver plus vite le bon artisan", "Une entrée plus claire vers le devis ou le parcours urgence"];
const services = [{
  id: 1,
  title: "Rénovation intérieure",
  description: "Transformez vos espaces de vie avec des artisans qualifiés.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/interior_renovation_modern_living_room.png",
  intro: "Réaménagement des pièces, cuisine, salle de bains, finitions et confort du quotidien : nous structurons votre projet avec les bons corps de métier.",
  services: ["Aménagement et redistribution des espaces", "Cuisine et salle de bains", "Revêtements, peinture et finitions", "Plomberie et électricité associées"],
  formSlug: "renovation-interieure"
}, {
  id: 2,
  title: "Rénovation extérieure",
  description: "Façade, aménagements et amélioration durable de l’extérieur.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/exterior_renovation_house_facade.png",
  intro: "Nous vous orientons vers les bons professionnels pour protéger, rénover et valoriser durablement l'extérieur de votre habitat.",
  services: ["Ravalement de façade", "Isolation par l'extérieur", "Terrasses et aménagements", "Finitions extérieures"],
  formSlug: "renovation-exterieure"
}, {
  id: 3,
  title: "Couverture",
  description: "Toiture, étanchéité et interventions ciblées sur l’enveloppe.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/emergency_roofing_service.png",
  intro: "Réfection de toiture, étanchéité, fuites et couverture : nous vous aidons à cadrer le bon besoin et à lancer la bonne catégorie de formulaire.",
  services: ["Réfection de toiture", "Étanchéité", "Recherche de fuite", "Réparations ponctuelles"],
  formSlug: "couverture"
}, {
  id: 4,
  title: "Plomberie",
  description: "Installation, réparation et interventions ciblées.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/plumbing_installation_repair_work.png",
  intro: "Installation sanitaire, fuites, débouchage ou remise en conformité : nous vous aidons à lancer le bon parcours rapidement.",
  services: ["Installation sanitaire", "Recherche et réparation de fuite", "Débouchage et dépannage", "Mise aux normes"],
  formSlug: "plomberie"
}, {
  id: 5,
  title: "Électricité",
  description: "Travaux électriques sécurisés et conformes.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/electrical_work_panel_installation.png",
  intro: "Mise aux normes, tableau électrique, éclairage, équipements et sécurité : un seul point d'entrée pour trouver le bon électricien.",
  services: ["Tableau électrique", "Mise aux normes", "Éclairage et prises", "Diagnostic et sécurisation"],
  formSlug: "electricite"
}, {
  id: 6,
  title: "Maçonnerie",
  description: "Structure, ouvertures, dalles et ouvrages maçonnés.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/masonry_brick_wall_construction.png",
  intro: "Création de murs, ouvertures, dalles et reprises structurelles : nous cadrons votre besoin avec des artisans adaptés.",
  services: ["Dalles et fondations", "Murs et cloisons maçonnées", "Ouvertures et reprises", "Réparations structurelles"],
  formSlug: "maconnerie"
}, {
  id: 7,
  title: "Performance énergétique",
  description: "Isolation, ventilation et optimisation énergétique.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/energy_efficiency_insulation_installation.png",
  intro: "Réduction des consommations, confort thermique et orientation vers les travaux les plus efficaces pour votre habitat.",
  services: ["Isolation thermique", "Ventilation et VMC", "Audit énergétique", "Optimisation globale"],
  formSlug: "isolation"
}, {
  id: 8,
  title: "Chauffage",
  description: "Installation et modernisation de vos systèmes de chauffage.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/heating_system_radiator_installation.png",
  intro: "Pompes à chaleur, chaudières, radiateurs ou plancher chauffant : trouvez le bon spécialiste selon votre configuration.",
  services: ["Pompes à chaleur", "Chaudières et remplacement", "Radiateurs et planchers chauffants", "Entretien et optimisation"],
  formSlug: "chauffage"
}, {
  id: 9,
  title: "Climatisation",
  description: "Solutions de climatisation et PAC pour toute l'année.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/air_conditioning_unit_installation.png",
  intro: "Installation, remplacement ou dépannage de climatisation : nous vous orientons selon le bon système et la bonne urgence.",
  services: ["Mono-split et multi-split", "PAC air/air", "Entretien et maintenance", "Dépannage ciblé"],
  formSlug: "climatisation"
}, {
  id: 10,
  title: "Panneaux solaires",
  description: "Photovoltaïque et autoconsommation.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/solar_panels_roof_installation.png",
  intro: "Étude, installation et accompagnement pour produire votre propre électricité et mieux structurer votre projet solaire.",
  services: ["Installation photovoltaïque", "Autoconsommation", "Batterie et stockage", "Étude de faisabilité"],
  formSlug: "photovoltaique"
}, {
  id: 11,
  title: "Énergies renouvelables",
  description: "Solutions durables pour un habitat plus autonome.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/renewable_energy_wind_turbine_field.png",
  intro: "Nous vous aidons à cadrer vos projets d'énergies renouvelables et à identifier les solutions les plus pertinentes.",
  services: ["Solaire thermique", "Géothermie", "Biomasse", "Solutions hybrides"],
  formSlug: "photovoltaique"
}, {
  id: 12,
  title: "Petits travaux",
  description: "Bricolage, montage et réparations du quotidien.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/handyman_small_repairs_tools.png",
  intro: "Pour les besoins simples, rapides ou ponctuels, nous vous dirigeons vers le bon artisan sans alourdir le parcours.",
  services: ["Montage de meubles", "Petites réparations", "Pose d'équipements", "Interventions rapides"],
  formSlug: "renovation-interieure"
}, {
  id: 13,
  title: "Peinture et décoration",
  description: "Rafraîchissement, décoration et finitions.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/painting_decoration_interior_room.png",
  intro: "Murs, plafonds, enduits décoratifs et remise au propre : une entrée claire pour transformer votre intérieur.",
  services: ["Peinture intérieure", "Enduits et finitions", "Papiers peints décoratifs", "Conseils en décoration"],
  formSlug: "peinture"
}, {
  id: 14,
  title: "Carrelage et revêtements",
  description: "Pose de carrelage, parquet et revêtements de sol.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/tiling_floor_installation_work.png",
  intro: "Du sol intérieur aux espaces humides, nous vous aidons à cadrer le bon besoin et la bonne finition.",
  services: ["Carrelage intérieur et extérieur", "Parquet et stratifié", "Faïence", "Préparation de support"],
  formSlug: "carrelage"
}, {
  id: 15,
  title: "Menuiserie",
  description: "Fenêtres, portes et agencements sur mesure.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/carpentry_custom_woodwork_furniture.png",
  intro: "Menuiseries extérieures ou agencement intérieur : nous vous orientons vers le bon artisan et le bon type de projet.",
  services: ["Fenêtres et portes", "Placards et rangements", "Escaliers et agencements", "Menuiseries sur mesure"],
  formSlug: "menuiseries"
}];
export default function NosServicesPage() {
  const [selectedService, setSelectedService] = useState<(typeof services)[0] | null>(null);
  return <div className="min-h-screen bg-white text-slate-900">
      <EnTete />

      <main>
        <section className="relative overflow-hidden bg-slate-950 pt-16">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(249,115,22,0.18),transparent_32%),radial-gradient(circle_at_bottom_right,rgba(248,154,22,0.14),transparent_28%)]" />
          <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(15,23,42,0.94)_0%,rgba(15,23,42,0.88)_100%)]" />

          <div className="relative z-10 mx-auto max-w-7xl px-4 pb-14 pt-12 sm:px-6 lg:px-8 lg:pb-24 lg:pt-24">
            <div className="max-w-3xl">
              <div className="inline-flex items-center gap-2 rounded-full border border-orange-300/30 bg-white/8 px-4 py-2 text-sm font-medium text-orange-100 backdrop-blur">
                <Briefcase className="h-4 w-4" />
                Nos services
              </div>

              <h1 className="mt-6 text-3xl font-bold leading-tight text-white sm:text-5xl lg:text-6xl">
                Tous les métiers pour rénover, équiper et dépanner votre habitat.
              </h1>

              <p className="mt-5 max-w-2xl text-base leading-7 text-white/82 sm:text-xl sm:leading-8">
                Une entrée plus claire pour repérer le bon métier, demander un devis au bon endroit et gagner du temps
                dès les premières minutes.
              </p>

              <div className="mt-7 flex flex-col gap-3 sm:flex-row">
                <Button asChild className="h-13 rounded-2xl bg-orange-500 px-6 text-sm font-semibold text-white shadow-[0_18px_40px_rgba(249,115,22,0.28)] transition hover:bg-orange-600 sm:h-14 sm:px-7 sm:text-base">
                  <Link to="/demande-de-devis/">
                    Demander un devis
                    <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
                  </Link>
                </Button>

                <Button asChild className="h-13 rounded-2xl border border-white/18 bg-white/10 px-6 text-sm font-semibold text-white backdrop-blur transition hover:bg-white/14 sm:h-14 sm:px-7 sm:text-base">
                  <Link to="/depannage/">
                    Lancer un dépannage
                    <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 pt-5 sm:px-6 lg:px-8">
          <div className="mx-auto grid max-w-6xl gap-0 overflow-hidden rounded-[26px] border border-orange-100 bg-white shadow-[0_24px_60px_rgba(15,23,42,0.12)] md:grid-cols-3">
            {reperes.map((repere, index) => <div key={repere} className={`flex items-start gap-4 px-6 py-6 ${index < 2 ? "border-b border-orange-100 md:border-b-0 md:border-r" : ""}`}>
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-orange-50 text-orange-500">
                  {index === 0 ? <BadgeCheck className="h-5 w-5" /> : index === 1 ? <Wrench className="h-5 w-5" /> : <ShieldCheck className="h-5 w-5" />}
                </div>
                <div className="text-sm leading-6 text-slate-600">{repere}</div>
              </div>)}
          </div>
        </section>

        <section className="bg-white px-4 py-14 sm:px-6 lg:px-8 lg:py-20">
          <div className="mx-auto max-w-6xl">
            <div className="max-w-2xl text-center mx-auto">
              <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
                Nos domaines d’intervention
              </h2>
            </div>

            <div className="mt-12 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
              {services.map(service => <Card key={service.id} className="group flex h-full flex-col overflow-hidden rounded-[24px] border border-orange-100 bg-white shadow-[0_18px_45px_rgba(15,23,42,0.08)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_rgba(15,23,42,0.12)]">
                  <button type="button" onClick={() => setSelectedService(service)} className="relative block aspect-[4/3] w-full overflow-hidden text-left">
                    <img src={service.image} alt={service.title} className="h-full w-full object-cover transition duration-500 group-hover:scale-[1.04]" />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 via-slate-900/8 to-transparent" />
                    <div className="absolute left-5 top-5 inline-flex items-center rounded-full bg-white px-4 py-2 text-sm font-semibold text-orange-600 shadow-[0_12px_24px_rgba(15,23,42,0.16)]">
                      Voir le détail
                    </div>
                  </button>

                  <CardContent className="flex flex-1 flex-col p-6">
                    <h3 className="text-[2rem] font-bold tracking-tight text-slate-900">{service.title}</h3>
                    <p className="mt-3 text-base leading-8 text-slate-600">{service.description}</p>

                    <div className="mt-auto flex flex-col gap-3 pt-6">
                      <Button asChild className="h-12 rounded-2xl bg-orange-500 text-sm font-semibold text-white hover:bg-orange-600">
                        <Link to={`/demande-de-devis/${service.formSlug}`}>Demander un devis</Link>
                      </Button>

                      <Button type="button" variant="outline" onClick={() => setSelectedService(service)} className="h-12 rounded-2xl border-orange-200 text-sm font-semibold text-slate-900 hover:bg-orange-50 hover:text-orange-600">
                        Voir le détail
                        <ChevronRight className="ml-2 h-4 w-4" />
                      </Button>
                    </div>
                  </CardContent>
                </Card>)}
            </div>
          </div>
        </section>

        {selectedService && <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/70 p-4 backdrop-blur-sm" onClick={() => setSelectedService(null)}>
            <div className="max-h-[88vh] w-full max-w-3xl overflow-y-auto rounded-[28px] bg-white shadow-[0_28px_80px_rgba(15,23,42,0.34)]" onClick={event => event.stopPropagation()}>
              <div className="flex items-center justify-between border-b border-orange-100 px-6 py-5">
                <div>
                  <div className="text-sm font-semibold uppercase tracking-[0.14em] text-orange-500">Détail métier</div>
                  <h3 className="mt-2 text-2xl font-bold text-slate-900">{selectedService.title}</h3>
                </div>
                <button type="button" onClick={() => setSelectedService(null)} className="flex h-11 w-11 items-center justify-center rounded-2xl bg-slate-100 text-slate-500 transition hover:bg-slate-200 hover:text-slate-900" aria-label="Fermer">
                  <X className="h-5 w-5" />
                </button>
              </div>

              <div className="p-6 md:p-8">
                <div className="overflow-hidden rounded-[22px]">
                  <img src={selectedService.image} alt={selectedService.title} className="h-[260px] w-full object-cover md:h-[340px]" />
                </div>

                <p className="mt-6 text-base leading-8 text-slate-600">{selectedService.intro}</p>

                <div className="mt-8 grid gap-4 sm:grid-cols-2">
                  {selectedService.services.map(item => <div key={item} className="flex items-start gap-3 rounded-[20px] border border-orange-100 bg-orange-50/55 px-4 py-4 text-slate-700">
                      <BadgeCheck className="mt-0.5 h-5 w-5 flex-shrink-0 text-orange-500" />
                      <span className="text-sm leading-6">{item}</span>
                    </div>)}
                </div>

                <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                  <Button asChild className="h-12 rounded-2xl bg-orange-500 px-6 text-sm font-semibold text-white hover:bg-orange-600">
                    <Link to={`/demande-de-devis/${selectedService.formSlug}`}>Demander un devis</Link>
                  </Button>

                  <Button asChild variant="outline" className="h-12 rounded-2xl border-orange-200 px-6 text-sm font-semibold text-slate-900 hover:bg-orange-50 hover:text-orange-600">
                    <Link to="/depannage/">Lancer un dépannage</Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>}
      </main>

      <PiedDePage />
    </div>;
}